<div class="filter">
  <div class="spen-ly-modal spen-ly-static" id="modal">
    <div class="modal-dialog">
      <div class="inner">
        <div class="modal-heading">
          <span class="top-btn-close" (click)="closeSelectActivityModal()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
          <h2 class="heading-text">既存の活動記録</h2>
        </div>

        @if (dataLoaded()) {
          <div
            class="modal-content"
            infinite-scroll
            infiniteScrollDistance="1"
            infiniteScrollThrottle="200"
            [infiniteScrollDisabled]="!nextPage"
            [scrollWindow]="false"
            (scrolled)="onLoadMore()"
          >
            @if (!isShowFilter) {
              <div class="spen-util-link block-search" (click)="showFilter()"><i class="fa fa-search"></i>検索</div>
            } @else {
              <app-dropdown-filter-activities (closeFilter)="closeFilter()" (submitFilter)="doFilter($event)">
              </app-dropdown-filter-activities>
            }
            <div class="activities">
              <div class="info-count">{{ total_records }}件</div>
              <div class="space-flex-list">
                <ul>
                  @for (activityRecord of activities; track activityRecord.id; let isFirst = $first) {
                    <li class="list-item" (click)="handleClickActivity(activityRecord)" [class.is-first]="isFirst">
                      <app-student-activity-item [activityRecord]="activityRecord"></app-student-activity-item>
                    </li>
                  }
                </ul>
              </div>
            </div>
            @if (isLoading) {
              <div class="spen-mod-flex-loading">
                <div class="loading-icon"></div>
              </div>
            }
          </div>
        } @else {
          <div class="modal-content">
            <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
